class CornerstoneWADOImageLoaderMZYL {
  constructor () {
    this._rootVue = null
  }

  static getInstance () {
    if (!CornerstoneWADOImageLoaderMZYL.instance) {
      CornerstoneWADOImageLoaderMZYL.instance = new CornerstoneWADOImageLoaderMZYL()
      return CornerstoneWADOImageLoaderMZYL.instance
    }
    return CornerstoneWADOImageLoaderMZYL.instance
  }

  get rootVue () {
    return this._rootVue
  }

  webWorkerManagerInitialize () {
    var config = {
      maxWebWorkers: 1,
      webWorkerPath: './static/dist/cornerstoneWADOImageLoaderWebWorker.js',
      taskConfiguration: {
        decodeTask: {
          codecsPath: './static/dist/cornerstoneWADOImageLoaderCodecs.js'
        }
      }
    }
    cornerstoneWADOImageLoader.webWorkerManager.initialize(config)
  }

  terminate () {
    cornerstoneWADOImageLoader.webWorkerManager.terminate()
  }

  mixin (rootVue) {
    this._rootVue = rootVue
  }
}

export default CornerstoneWADOImageLoaderMZYL.getInstance()
